import moment from 'moment';

export const isDateOlderThanMonth = (date) => {
  const current = moment();
  const checkingDate = moment(date, 'YYYY-MM-DD');

  return current.get('year') === checkingDate.get('year') && current.get('month') - 1 > checkingDate.get('month');
};

export const alphabeticalSorting = (a, b) => {
  const A = a.title?.props?.children;
  const B = b.title?.props?.children;
  if (A > B) {
    return -1;
  }
  if (B > A) {
    return 1;
  }
  return 0;
};
